import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

interface RecruiterScreeningWarningCalloutProps {
  showCallMeNow?: boolean;
}

export function RecruiterScreeningWarningCallout(props: RecruiterScreeningWarningCalloutProps) {
  const { showCallMeNow = true } = props;

  return (
    <Box paddingX={2}>
      <Stack
        direction="row"
        spacing={2}
        padding={4}
        sx={(theme) => ({
          backgroundColor: theme.palette.warning.main,
          borderRadius: theme.shape.borderRadius,
        })}
        alignItems="center"
      >
        <Box padding={3} sx={{ color: (theme) => theme.palette.text.primary }}>
          <CbhIcon type="triangle-exclamation" />
        </Box>
        <Text
          sx={{
            lineHeight: "1.5rem",
            flex: 1,
          }}
        >
          <Text
            inline
            sx={{
              fontWeight: 800,
            }}
          >
            Your interview is not booked
          </Text>{" "}
          until you complete this call with Clipboard.
          {showCallMeNow && " We'll call you within 15 minutes!"}
        </Text>
      </Stack>
    </Box>
  );
}
